import React from "react";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import HeaderImage from '../../images/ASDASD.png'
import dashboardBtn from '../../images/dashboardBtn.png'
import telegram from '../../images/telegram.png'
import twitter from '../../images/twitter.png'
import medium from '../../images/medium.png'


const useStyles = makeStyles((theme) => ({
  logo: {
      maxWidth: 130
  },
  dashboardBtn: {
    maxWidth: 200
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'unset',
  },
  links: {
    backgroundColor:'#21242e !important',
    color: '#fff',
    padding: '0px 12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    '&:hover': {
      color: "#f4f4f4",
      TextDecoder: 'none'
   },
  }
}));

const Header = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" style={{border: '1px solid #ffa83e',
      backgroundColor: '#ffa83e'}}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="QMF---Header"
      >
        <Grid
            xs={12}
            sm={7}
        >
            <h1>
                <span style={{color:'#21242E'}}>Are you ready for</span>
                <br />
            </h1>
            <h2 style={{fontSize: '56px',color:'#21242E'}}>the next <span  className="Moon---Header">moonshot? </span></h2>
            <p className=" my-3" style={{color:'#21242e',fontSize: '18px'}}>FTM-MOON is a hyper-deflationary reward tokenthat operates on the FANTOM network. Users can simply hold FMF tokens and receive rewards in FTM tokens for every transaction automatically in a few hours.
            <br />
            <br />
            Every transaction tax is redistributed for automatic liquidity generation, token burning and holder rewards to help generate passive income for long-term holders and keep buying pressure higher than selling pressure.<br></br>
                
                <strong style={{color:'#21242e !important'}}>Token address :<u> <a href="https://spookyswap.finance/swap?outputCurrency=0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c" style={{color:'black'}}>0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c</a></u></strong>
                <br className='d-none d-md-block' />
                <div className="mt-4">
                    <a href="https://spookyswap.finance/swap?outputCurrency=0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c" className={classes.links + " text-center d-block d-sm-inline-flex"} style={{border: '1px solid #ffa83e',padding: '10px 10px',
                    backgroundColor: '#21242e !important',padding:'10px 39px'}}>BUY NOW</a>
                    <a href="/dashboard" className={classes.links + "  text-center d-block d-sm-inline-flex ml-sm-3"} style={{border: '1px solid #ffa83e',padding: '10px 10px',
                    backgroundColor: '#21242e !important',padding:'10px 23px'}}>Dashboard</a>
                </div>

            </p>
            <div className="d-sm-flex pt-3">
             <span style={{fontSize: '30px',fontWeight: '800',color: '#21242e'}}> Stay Connected : </span> 
              <a href="https://fantom-moon.medium.com/" target="_blank">
                <img src={medium} className="img-fluid" style={{maxWidth: 50}} />
              </a>
              <a href="https://t.me/FANTOMMOON" target="_blank">
                <img src={telegram} className="img-fluid" style={{maxWidth: 50}} />
              </a>
              <a href="https://twitter.com/fantommoon2" target="_blank">
                <img src={twitter} className="img-fluid" style={{maxWidth: 50}} />
              </a>
              </div>
            
        </Grid>
        <Grid
            xs={12}
            sm={5}
            className="text-center mt-5 mt-sm-0 d-none d-sm-inline-block"
        >
            {/* <img src={HeaderImage} alt="Header Image" className="img-fluid w-100" style={{maxWidth: 550}} /> */}
            <div class="ag-stars-block">
            <img src={HeaderImage} alt="Header Image" className="img-fluid w-100 fmm---header_black_bg" style={{maxWidth: 550}} />
              <div class="ag-rocket_box ag-rocket_box__running">
                <div class="ag-rocket_rocket">
                <div class="ag-rocket_flame-main"></div>
                <div class="ag-rocket_flame ag-rocket_flame-top-left"></div>
                <div class="ag-rocket_flame ag-rocket_flame-bottom-left"></div>
                <div class="ag-rocket_flame ag-rocket_flame-top-right"></div>
                <div class="ag-rocket_flame ag-rocket_flame-bottom-right"></div>
                </div>
              </div>
            </div>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Header;
